/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: z42h7wgleYEz

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeCaseStudiesSectionBanner.module.css"; // plasmic-import: z42h7wgleYEz/css

createPlasmicElementProxy;

export type PlasmicHomeCaseStudiesSectionBanner__VariantMembers = {
  type: "meharry" | "uconn" | "usc";
};
export type PlasmicHomeCaseStudiesSectionBanner__VariantsArgs = {
  type?: SingleChoiceArg<"meharry" | "uconn" | "usc">;
};
type VariantPropType = keyof PlasmicHomeCaseStudiesSectionBanner__VariantsArgs;
export const PlasmicHomeCaseStudiesSectionBanner__VariantProps =
  new Array<VariantPropType>("type");

export type PlasmicHomeCaseStudiesSectionBanner__ArgsType = {};
type ArgPropType = keyof PlasmicHomeCaseStudiesSectionBanner__ArgsType;
export const PlasmicHomeCaseStudiesSectionBanner__ArgProps =
  new Array<ArgPropType>();

export type PlasmicHomeCaseStudiesSectionBanner__OverridesType = {
  caseStudyBanner?: Flex__<"div">;
  desktop?: Flex__<"div">;
  top2?: Flex__<"div">;
  quoteLogo?: Flex__<"div">;
  img?: Flex__<"div">;
  titleContainer?: Flex__<"div">;
  title2?: Flex__<"h5">;
  stats?: Flex__<"div">;
  block?: Flex__<"div">;
  val?: Flex__<"h6">;
  desc?: Flex__<"p">;
  block2?: Flex__<"div">;
  val2?: Flex__<"h6">;
  desc2?: Flex__<"p">;
};

export interface DefaultHomeCaseStudiesSectionBannerProps {
  type?: SingleChoiceArg<"meharry" | "uconn" | "usc">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeCaseStudiesSectionBanner__RenderFunc(props: {
  variants: PlasmicHomeCaseStudiesSectionBanner__VariantsArgs;
  args: PlasmicHomeCaseStudiesSectionBanner__ArgsType;
  overrides: PlasmicHomeCaseStudiesSectionBanner__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"caseStudyBanner"}
      data-plasmic-override={overrides.caseStudyBanner}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.caseStudyBanner,
        {
          [sty.caseStudyBannertype_meharry]: hasVariant(
            $state,
            "type",
            "meharry"
          ),
          [sty.caseStudyBannertype_uconn]: hasVariant($state, "type", "uconn"),
          [sty.caseStudyBannertype_usc]: hasVariant($state, "type", "usc")
        }
      )}
    >
      <div
        data-plasmic-name={"desktop"}
        data-plasmic-override={overrides.desktop}
        className={classNames(projectcss.all, sty.desktop)}
      >
        <div
          data-plasmic-name={"top2"}
          data-plasmic-override={overrides.top2}
          className={classNames(projectcss.all, sty.top2, {
            [sty.top2type_meharry]: hasVariant($state, "type", "meharry"),
            [sty.top2type_uconn]: hasVariant($state, "type", "uconn"),
            [sty.top2type_usc]: hasVariant($state, "type", "usc")
          })}
        >
          <div
            data-plasmic-name={"quoteLogo"}
            data-plasmic-override={overrides.quoteLogo}
            className={classNames(projectcss.all, sty.quoteLogo)}
          >
            <div
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              className={classNames(projectcss.all, sty.img, {
                [sty.imgtype_meharry]: hasVariant($state, "type", "meharry"),
                [sty.imgtype_uconn]: hasVariant($state, "type", "uconn")
              })}
            />
          </div>
          <div
            data-plasmic-name={"titleContainer"}
            data-plasmic-override={overrides.titleContainer}
            className={classNames(projectcss.all, sty.titleContainer)}
          >
            <h5
              data-plasmic-name={"title2"}
              data-plasmic-override={overrides.title2}
              className={classNames(
                projectcss.all,
                projectcss.h5,
                projectcss.__wab_text,
                sty.title2,
                {
                  [sty.title2type_meharry]: hasVariant(
                    $state,
                    "type",
                    "meharry"
                  ),
                  [sty.title2type_uconn]: hasVariant($state, "type", "uconn")
                }
              )}
            >
              {hasVariant($state, "type", "uconn")
                ? "A Holistic Approach to Meeting Evolving Industry Reporting Standards"
                : hasVariant($state, "type", "meharry")
                  ? "Rotation-Specific Quizzes Assigned by MyEvaluations.com \nPredict Board Passing Rate"
                  : "Three Year Follow-Up: Streamlining the Onboarding and Credentialing Process with MyEvaluations.com"}
            </h5>
          </div>
        </div>
        <div
          data-plasmic-name={"stats"}
          data-plasmic-override={overrides.stats}
          className={classNames(projectcss.all, sty.stats)}
        >
          <div
            data-plasmic-name={"block"}
            data-plasmic-override={overrides.block}
            className={classNames(projectcss.all, sty.block)}
          >
            <h6
              data-plasmic-name={"val"}
              data-plasmic-override={overrides.val}
              className={classNames(
                projectcss.all,
                projectcss.h6,
                projectcss.__wab_text,
                sty.val,
                {
                  [sty.valtype_meharry]: hasVariant($state, "type", "meharry"),
                  [sty.valtype_uconn]: hasVariant($state, "type", "uconn")
                }
              )}
            >
              {hasVariant($state, "type", "uconn")
                ? "142"
                : hasVariant($state, "type", "meharry")
                  ? "+78%"
                  : "50%"}
            </h6>
            <p
              data-plasmic-name={"desc"}
              data-plasmic-override={overrides.desc}
              className={classNames(
                projectcss.all,
                projectcss.p,
                projectcss.__wab_text,
                sty.desc,
                {
                  [sty.desctype_meharry]: hasVariant($state, "type", "meharry"),
                  [sty.desctype_uconn]: hasVariant($state, "type", "uconn")
                }
              )}
            >
              {hasVariant($state, "type", "uconn")
                ? "Number of tracked curricular milestones"
                : hasVariant($state, "type", "meharry")
                  ? "Improvement in board exam pass rate"
                  : "Reduction in effort spent onboarding new hires"}
            </p>
          </div>
          <div
            data-plasmic-name={"block2"}
            data-plasmic-override={overrides.block2}
            className={classNames(projectcss.all, sty.block2, {
              [sty.block2type_meharry]: hasVariant($state, "type", "meharry")
            })}
          >
            <h6
              data-plasmic-name={"val2"}
              data-plasmic-override={overrides.val2}
              className={classNames(
                projectcss.all,
                projectcss.h6,
                projectcss.__wab_text,
                sty.val2,
                {
                  [sty.val2type_meharry]: hasVariant($state, "type", "meharry"),
                  [sty.val2type_uconn]: hasVariant($state, "type", "uconn")
                }
              )}
            >
              {hasVariant($state, "type", "uconn")
                ? "+22"
                : hasVariant($state, "type", "meharry")
                  ? "83%"
                  : "12.7k"}
            </h6>
            <p
              data-plasmic-name={"desc2"}
              data-plasmic-override={overrides.desc2}
              className={classNames(
                projectcss.all,
                projectcss.p,
                projectcss.__wab_text,
                sty.desc2,
                {
                  [sty.desc2type_meharry]: hasVariant(
                    $state,
                    "type",
                    "meharry"
                  ),
                  [sty.desc2type_uconn]: hasVariant($state, "type", "uconn")
                }
              )}
            >
              {hasVariant($state, "type", "uconn")
                ? "Number of added sub-competencies meeting NAS requirements"
                : hasVariant($state, "type", "meharry")
                  ? "Sensitivity of predicting passing the board examination"
                  : "Contracts processed for the past four academic years"}
            </p>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  caseStudyBanner: [
    "caseStudyBanner",
    "desktop",
    "top2",
    "quoteLogo",
    "img",
    "titleContainer",
    "title2",
    "stats",
    "block",
    "val",
    "desc",
    "block2",
    "val2",
    "desc2"
  ],
  desktop: [
    "desktop",
    "top2",
    "quoteLogo",
    "img",
    "titleContainer",
    "title2",
    "stats",
    "block",
    "val",
    "desc",
    "block2",
    "val2",
    "desc2"
  ],
  top2: ["top2", "quoteLogo", "img", "titleContainer", "title2"],
  quoteLogo: ["quoteLogo", "img"],
  img: ["img"],
  titleContainer: ["titleContainer", "title2"],
  title2: ["title2"],
  stats: ["stats", "block", "val", "desc", "block2", "val2", "desc2"],
  block: ["block", "val", "desc"],
  val: ["val"],
  desc: ["desc"],
  block2: ["block2", "val2", "desc2"],
  val2: ["val2"],
  desc2: ["desc2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  caseStudyBanner: "div";
  desktop: "div";
  top2: "div";
  quoteLogo: "div";
  img: "div";
  titleContainer: "div";
  title2: "h5";
  stats: "div";
  block: "div";
  val: "h6";
  desc: "p";
  block2: "div";
  val2: "h6";
  desc2: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeCaseStudiesSectionBanner__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeCaseStudiesSectionBanner__VariantsArgs;
    args?: PlasmicHomeCaseStudiesSectionBanner__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeCaseStudiesSectionBanner__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeCaseStudiesSectionBanner__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeCaseStudiesSectionBanner__ArgProps,
          internalVariantPropNames:
            PlasmicHomeCaseStudiesSectionBanner__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeCaseStudiesSectionBanner__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "caseStudyBanner") {
    func.displayName = "PlasmicHomeCaseStudiesSectionBanner";
  } else {
    func.displayName = `PlasmicHomeCaseStudiesSectionBanner.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeCaseStudiesSectionBanner = Object.assign(
  // Top-level PlasmicHomeCaseStudiesSectionBanner renders the root element
  makeNodeComponent("caseStudyBanner"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    top2: makeNodeComponent("top2"),
    quoteLogo: makeNodeComponent("quoteLogo"),
    img: makeNodeComponent("img"),
    titleContainer: makeNodeComponent("titleContainer"),
    title2: makeNodeComponent("title2"),
    stats: makeNodeComponent("stats"),
    block: makeNodeComponent("block"),
    val: makeNodeComponent("val"),
    desc: makeNodeComponent("desc"),
    block2: makeNodeComponent("block2"),
    val2: makeNodeComponent("val2"),
    desc2: makeNodeComponent("desc2"),

    // Metadata about props expected for PlasmicHomeCaseStudiesSectionBanner
    internalVariantProps: PlasmicHomeCaseStudiesSectionBanner__VariantProps,
    internalArgProps: PlasmicHomeCaseStudiesSectionBanner__ArgProps
  }
);

export default PlasmicHomeCaseStudiesSectionBanner;
/* prettier-ignore-end */
